export const ConfirmationModal = ({ open, message, onConfirm, onCancel }) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
            <div className="bg-white rounded-lg shadow-lg p-6 min-w-[300px] max-w-[90vw]">
                <div className="mb-4 text-lg font-semibold">Confirmation</div>
                <div className="mb-6">{message}</div>
                <div className="flex justify-end gap-2">
                    <button
                        className="px-4 py-1 rounded bg-gray-200 hover:bg-gray-300 text-gray-800"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-4 py-1 rounded bg-green-600 hover:bg-green-700 text-white"
                        onClick={onConfirm}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};